import React from 'react';
import { useTranslation } from 'next-i18next';
import { FavoriteRounded, FavoriteBorderRounded } from '@mui/icons-material';
import BaseControlButton, { IControlButtonProps } from '../control-base';

const FavoriteControlButton: React.FC<IControlButtonProps> = (props) => {
  const { active, className = '', onClick = () => {} } = props;

  const { t: tButtons } = useTranslation('buttons');

  const icon = active ? (
    <FavoriteRounded fontSize="inherit" />
  ) : (
    <FavoriteBorderRounded fontSize="inherit" />
  );
  const text = active ? tButtons('remove') : tButtons('add');

  return (
    <BaseControlButton
      className={className}
      icon={icon}
      text={text}
      onClick={onClick}
    />
  );
};

export default FavoriteControlButton;
